import { render, staticRenderFns } from "./ModalSettingAccountDeleteAccount.vue?vue&type=template&id=87adad0c&"
import script from "./ModalSettingAccountDeleteAccount.vue?vue&type=script&lang=js&"
export * from "./ModalSettingAccountDeleteAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports